var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-alert text-left font-weight-bold py-3 px-4",style:({ ..._vm.backgroundClass, ..._vm.borderClass })},[_vm._v(" "+_vm._s(_vm.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }